import Joi from 'joi';
import { instagramRegex, tiktokPostRegex, youtubeRegex } from './constants';

export const logPostLinkSchema = Joi.object({
  postUrl: Joi.alternatives()
    .try(
      Joi.string().trim().required().regex(instagramRegex),
      Joi.string().trim().required().regex(tiktokPostRegex),
      Joi.string().trim().required().regex(youtubeRegex)
    )
    .messages({
      'any.required': 'URL is required',
      'string.empty': 'URL is required',
      'alternatives.match': 'Invalid Instagram / Tiktok / Youtube Post URL',
    }),
  postedDate: Joi.date().required().messages({
    'any.required': 'Posted Date is required',
  }),
});

export const logScreenshotSchema = Joi.object({
  postedDate: Joi.date().required().messages({
    'any.required': 'Posted Date is required',
  }),
});
